import React from 'react'
import { useTranslate } from '../TranslationText';
import { formatDate } from '../../helper/formatDate';
import CustomPopUp from '../CustomPopUp';
import { FetchStudBookHorseCompetitionthunk } from '../../Redux/StudBook/StudBookAction';
import CompetitionsTab from '../CompetitionsTab';
import PillBtn from '../PillBtn';
import { showWordsByNumber } from '../../helper/showFirstSixWords';
import { useDispatch, useSelector } from 'react-redux';
import { aedLogoStyle, getDirhamImage } from '../../common/cssclasses';
import { getFileName } from '../../helper/getFileName';
const BaseURL = process.env.REACT_APP_BASE_URL;

export default function AuctionHorse({ horse, auction }) {
    const currentlang = localStorage.getItem('eahsLang') ?? 'en';
    const { translate } = useTranslate();
    const dispatch = useDispatch();
    const handlePageChangeHorseCompetition = () => { }
    const renderPaginationHorseCompetition = () => { }
    const {

        studBookHorseCompetitionData,
        takeHorseCompetition,
        pageHorseCompetition,
        totalCountHorseCompetition,
    } = useSelector((state) => state.studBookSlice);
    const bidderId = '';
    const bidderNumber = '';
    return (
        <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 mb-main">
            <div className='bg-white  rtl   p-main border-15 p-3 h-100 d-flex flex-column' >
                <div className="mb-form-group">
                    <div className='position-relative border-15' style={{overflow:'hidden'}}>
                        <img
                            src={horse?.horseFeatureImage}
                            className="w-100 border-15"
                            alt={getFileName(horse?.horseFeatureImage)}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `${BaseURL}/assets/img/horseauction.png`;
                            }} />
                    </div>
                </div>
                <div className='horseCardTitle mb-form-group'>
                    {horse?.horseName} {horse?.isSemen == true ? translate('web.semen', 'semen') : ''}
                </div>
                <div className='horseCardDescription row mb-form-group'>
                    {horse?.horseSellingStatus?.toLowerCase() == 'sold' &&
                        <div className='col-12'>
                            <span className="fw-bold C89C66">
                                <i className=" fa fa-arrow-trend-up C89C66 me-2" />
                                {translate("web.sold", "sold")}
                            </span>
                        </div>
                    }
                    {horse?.horseSellingStatus?.toLowerCase() == 'unsold' &&
                        <div className='col-12'>
                            <span className="fw-bold C89C66">
                                <i className=" fa fa-arrow-trend-down C89C66 me-2" />
                                {translate("web.unSold", "sold")}
                            </span>
                        </div>
                    }

                    <div className='col-12'>
                        <span className="fw-bold">
                            <i className="fa-solid fa-chess-knight C89C66 me-2" />
                            {horse?.isSemen ? translate("web.semenNo", "Semen No") : translate("web.lotNo", "Lot No")}
                        </span>
                        <span className="fw-bold ms-2">
                            {horse?.lotNumber}
                        </span>
                    </div>
                    {!!horse?.horseBirthdate &&
                        <div className='col-12'>
                            <span className="fw-bold">
                                <i className=" fa fa-calendar C89C66 me-2" />
                                {translate("web.birthDate", "Birthdate")}
                            </span>
                            <span className="fw-bold ms-2">
                                {formatDate(new Date(horse?.horseBirthdate))}
                            </span>
                        </div>}
                    <div className='col-12'>
                        <span className="fw-bold">
                            <i className=" fa fa-palette C89C66 me-2" />
                            {translate("web.color", "color")}
                        </span>
                        <span className="fw-bold ms-2">
                            {!!horse?.horseColor
                                ? horse?.horseColor
                                : translate("web.unknown", "unknown")}
                        </span>
                    </div>
                    <div className='col-12'>
                        <span className="fw-bold">
                            <i className=" fa fa-user C89C66 me-2" />
                            {translate("web.owner", "Owner")}
                        </span>
                        <span className="fw-bold ms-2">
                            {!!horse?.horseOwner
                                ? horse?.horseOwner
                                : translate("web.unknown", "unknown")}
                        </span>
                    </div>
                    <div className='col-12'>
                        <span className="fw-bold">
                            <img src={getDirhamImage(currentlang)} alt='AED' style={aedLogoStyle} />
                            {translate("web.startingPrice", "Starting Price")}
                        </span>
                        <span className="fw-bold ms-2">
                            {horse?.startingPrice?.toLocaleString("en-US")} {translate('web.aed', 'AED')}
                        </span>
                    </div>

                </div>
                <div className='horseCardTitle'>
                    {translate('web.horsePerformance', 'horse Performance')}
                </div>
                <CustomPopUp
                    key={'popup'}
                    trigger={<p className='noMarginBottomForP mb-form-group' dangerouslySetInnerHTML={{ __html: showWordsByNumber(horse?.horseDescription ?? "", 55, true, translate) }} />}
                    title={translate('web.horsePerformance', 'horse Performance')}
                    content={<p className='noMarginBottomForP' dangerouslySetInnerHTML={{ __html: horse?.horseDescription }} />}
                />
                <div className='row rtl mt-auto'>
                    <CustomPopUp
                        key={'web.results'}
                        trigger={<div className="col-sm-6 col-md-6 col-12 mb-sm-0 mb-3">
                            <PillBtn
                                isSubmitBtn
                                isNoAction
                                isNoMargin
                                text={translate('web.results', 'Results')}
                                isRed={true} />
                        </div>}
                        onOpen={(e) => {
                            e.preventDefault();
                            let paramsHorseCompetition = {
                                id: horse?.horseId,
                                skip: 0,
                                take: 2000,
                                langauge: currentlang,
                            };
                            dispatch(FetchStudBookHorseCompetitionthunk(paramsHorseCompetition));
                        }}
                        title={translate('web.results', 'Results')}
                        content={<>
                            <CompetitionsTab
                                studBookHorseCompetitionData={studBookHorseCompetitionData}
                                translate={translate}
                                pageHorseCompetition={pageHorseCompetition}
                                handlePageChangeHorseCompetition={handlePageChangeHorseCompetition}
                                renderPaginationHorseCompetition={renderPaginationHorseCompetition}
                                totalCountHorseCompetition={totalCountHorseCompetition}
                                takeHorseCompetition={takeHorseCompetition}
                                isAuction={true}
                                className={'justify-content-start'}
                                isPopUp={true} />
                        </>}
                    />

                    <div className={"col-sm-6 col-md-6 col-12 "}>
                        <PillBtn
                            isNoMargin
                            text={translate("web.viewDetails", "View Details")}
                            routeName={`/horse-auction?horseid=${horse?.auctionHorseId}&auctionid=${auction?.id}&relatedUrls=${horse?.relatedUrls}&pidgreeid=${horse?.horseId}`} />
                    </div>
                    {auction?.isAuctionedOneByOne == false && auction?.isAuctionLive &&
                        <div className={"col-12   mt-2"}>
                            <PillBtn
                                text={translate("web.watchNow", "Watch Now")}
                                isNoMargin
                                isNoPadding
                                routeName={`/hybridBidding?auctionID=${auction?.id}&auctionHorseId=${horse?.auctionHorseId}`} />
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
